import { SINGLETON_DOCUMENT } from '@pkg/config/sanity/singletons';
import { singletonDocIdByName } from '@pkg/sanity-utils/singletonDocId';
import { useSanityData } from '@pkg/sanity-utils/composables/useSanityData';
import { siteManifest, type SiteManifestQuery } from '~/apis/sanity/queries/global';
import { useSiteManifestStore } from '~/app/stores/siteManifest';

export const useSiteManifestQuery = async() => {
  const { locale } = useI18n();
  const siteManifestStore = useSiteManifestStore();

  const response = await useSanityData<SiteManifestQuery>(siteManifest, reactive({
    locale,
    blogSingletonDocId: singletonDocIdByName(SINGLETON_DOCUMENT.ABOUT_FOOD_WASTE_BLOG_HOME, unref(locale)),
    careersSingletonDocId: singletonDocIdByName(SINGLETON_DOCUMENT.CAREERS_HOME, unref(locale)),
    pressReleaseSingletonDocId: singletonDocIdByName(SINGLETON_DOCUMENT.PRESS_HOME, unref(locale)),
  }));

  // Keep the store up-to-date with the query response, in case the params change, or live updates are turned active.
  watch(response.data, () => {
    if (response.data.value) {
      siteManifestStore.$patch(response.data.value);
    }
  }, {
    immediate: true,
    deep: true,
  });

  return response;
};
